import {event} from '../modules/event';
import {ajax} from '../modules/ajax';

class SearchCity {
	constructor(wrapper){
		this._createElements(wrapper);
		this._addEvents();
	}

	_createElements(wrapper){
        var self = this;

		this.wrapper = wrapper;
		//this.param = JSON.parse(this.wrapper.getAttribute('data-param'));
		this.field = document.querySelector('[data-SearchCity-field]');
		this.isSending = false;
		this.ajaxPath = this._defineAjaxPath();
        this.xmlhttp = false;
        this.resultBox = false;
        this.resultNav = false;
        this._returnCircuit = function(e){
            self._return.call(self, e);
        };
	}

    _defineAjaxPath(){
        var part = APP.vars.isDev ? '/_src/layouts' : '',
            ajaxPath = part + '/cities/search';

        return ajaxPath;
    }

	_addEvents(){
		var self = this;

        event.add(this.wrapper, 'submit', function(e){
            e.preventDefault();
        });

        event.add(this.field, 'click', function(e){
            e.stopPropagation();
        });

		event.add(this.field, 'keyup', function(e){
			self._search.call(self);
		});
	}

    _search(){
        var self = this;
        if(this.xmlhttp) this.xmlhttp.abort();

        this.xmlhttp = ajax({
            data:{"query": this.field.value},
            url:this.ajaxPath,
            callback: function(msg){
                self._addResult.call(self, msg);
            }
        });
    }

    _addResult(msg){

        var self = this,
            msg = JSON.parse(msg),
            arr = msg.suggestions,
            length = arr.length,
            inner='',
            cls;

        if (length) {
            if (!this.resultBox) this._createSearchBox();
            for(var i=0; i<length; i++){
                inner += '<a class="searchForm_resultLink" href="'+ arr[i].link +'">'+ arr[i].name +'</a>';
            }
            this.resultNav.innerHTML = inner;

            setTimeout(function(){
                cls = self.resultBox.className;
                if(cls.indexOf('js-active') == -1) self.resultBox.className = cls + ' js-active';
            }, 10);
        }
        else this._return();
    }

    _createSearchBox(){
        var self = this;

        this.resultBox = document.createElement('DIV');
        this.resultBox.className = 'searchForm_resultBox';
        this.resultNav = document.createElement('NAV');
        this.resultNav.className = 'searchForm_resultNav';
        this.resultBox.appendChild(this.resultNav);
        this.wrapper.appendChild(this.resultBox);
        event.add(document.body, 'click', self._returnCircuit);
    }

    _return(e){
        if(this.xmlhttp) {
            this.xmlhttp.abort();
            this.xmlhttp = false;
        }
        if(this.resultBox){
            this.wrapper.removeChild(this.resultBox);
            this.resultBox = false;
            this.resultNav = false;
            event.remove(document.body, 'click', this._returnCircuit);
        }
        //если кликнули на боди - очищаем поле
        if(e){
            this.field.value = '';
        }
    }
};

export {SearchCity};